import React from 'react'
import Manager from '../../public/components/Manager'
import FlowRecordDetail from './FlowRecordDetail'
import FlowRecordSelectDiv from './FlowRecordSelectDiv'
Ext.require('Ext.Toast')

const config = () => {
    const tiptools = [{
        _tool: '', icon: 'info-circle', ui: 'action', tooltip: o => {
            if (o['数据']) {
                var data = JSON.parse(o['数据'])
                var ret = ''
                for (var key in data) {
                    if (key.indexOf("_") == -1 && key.indexOf("[") == -1 && data[key] && typeof data[key] !== 'object') {
                        if (typeof data[key] === 'number' && data[key] % 1 === 0 && (data[key] + '').length == 13) {
                            try { ret += key + '：' + new Date(data[key]).toLocaleDateString() + '<br>' }
                            catch (e) { ret += key + '：' + data[key] + '<br>' }
                        }
                        else
                            ret += key + '：' + data[key] + '<br>'
                    }
                }
                return ret
            }
        }
    }]
    return {
        buttons: [
            { icon: 'plus', text: '添加 ...', cdt: ({ props: { type } }) => type && type === 'add', handler: ({ showDetail }) => Tyan.pubForm.showDialog('核签表单选择', props => <FlowRecordSelectDiv showDetail={showDetail} {...props} type={'其他类'} />) },
        ],
        columns: [
            { _text: '编号', minWidth: 150, locked: false, flex: 2, search: true, tools: tiptools },
            // { _text: '流程名称', minWidth: 150, flex: 2, search: true },
            { _text: '标题', minWidth: 150, flex: 2, search: true, filter: ['select'] },
            { _text: '状态名称', minWidth: 150, flex: 2, search: true, },
            { _text: '申请人', name: 'Creator', minWidth: 150, flex: 2, search: true },
            { _text: '当前操作人', name: '任务待执行人', minWidth: 150, flex: 2, search: true },
            { _: '数据', field: 'Data' },
            { _: 'RelevantPerson', field: 'RelevantPerson', search: true },
        ],
        onDoubleTap: ({ showDetail, refreshPage, props: { type } }, data) => {
            showDetail(props => <FlowRecordDetail {...props} id={data.id} type={type ? type : ''} />)
        }
    }
}
export default props => <Manager {...props} config={config} />